export async function ecofleet_getLocations(ownerAsiakasId, token) {
  const addr = "/api/ecofleet/getLocations/" + ownerAsiakasId;

  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, requestOptions);
  const data = await response.json();
  console.log("ecofleet_getLocations", data);
  if (response.ok) {
    return data;
  } else {
    throw new Error(data.message || "Failed to fetch locations");
  }
}

// begTimestamp=2025-05-14T00:00:00Z
// endTimestamp=2025-05-16T00:00:00Z
export async function ecoFleet_getRawData(ownerAsiakasId, objectId, begTime, endTime, token) {
  const addr = "/api/ecofleet/getVehicleRawData/" + ownerAsiakasId;

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      objectId: objectId,
      begTimestamp: begTime,
      endTimestamp: endTime,
    }),
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, requestOptions);
  const data = await response.json();
  console.log("ecofleet_getData", data);
  if (response.ok) {
    return data;
  } else {
    throw new Error(data.message || "Failed to fetch locations");
  }
}
